const playCustomBeep = (ctx: AudioContext) => {
    let osc = ctx.createOscillator();
    osc.onended = () => osc.disconnect();
    osc.connect(ctx.destination);
    osc.frequency.value = 3500;
    osc.start();
    osc.stop(ctx.currentTime + 0.04);
    // console.log("custom beep has been played");
}

export default {
    playCustomBeep
}